import React, { useState } from "react";
import authBg from "../../images/authBg.jpg";
import fmeLogo from "../../images/fmeLogo.png";
import Swal from "sweetalert2";
import { resources_EN } from "../componentUtils";
import { PostService } from "../../services/genericPostService";
import { Path } from "../../RoutesUtils";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    password: "",
    confirmPassword: "",
  });

  const navigate = useNavigate();

  /* On Change */
  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /* Validation */
  const validation = () => {
    if (formData.name.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyNameValidation
      );
      return false;
    }
    if (formData.email.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyEmailValidation
      );
      return false;
    }
    if (formData.password.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyPasswordValidation
      );
      return false;
    }
    if (formData.confirmPassword.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyConfirmPasswordValidation
      );
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.passwordMatchValidation
      );
      return false;
    }
    return true;
  };

  /* Submit */
  const submit = () => {
    const validate = validation();
    if (validate) {
      const data = {
        username: formData.name,
        email: formData.email,
        password: formData.password,
        confirm_password: formData.confirmPassword,
      };
      const url = "/fmeApi/signup.php";
      PostService(url, data, modal);
    }
  };

  /* Modal */
  const modal = (icon, title, text) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    }).then((res) => {
      if (res.isConfirmed && icon === resources_EN.success) {
        navigate(Path.login);
      }
    });
  };

  return (
    <div className="2xl:h-[120vh] lg:h-[150vh] flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 lg:block hidden">
        <img
          src={authBg}
          alt="Decorative flower"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="w-full lg:w-1/2 p-8 lg:p-12 lg:p-16 flex flex-col justify-center items-center">
        <div className="w-full max-w-md">
          <div className="flex justify-center">
            <img src={fmeLogo} alt="Forglem mig ej logo" className="2xl:w-auto lg:w-44 w-auto" />
          </div>

          <h1 className="text-2xl lg:text-3xl text-center text-green 2xl:my-16 my-12">
            Velkommen til FME
          </h1>

          <form>
            <div className="flex flex-col gap-8">
              <div className="w-full">
                <label htmlFor="fname" className="block text-sm font-medium">
                  Fuldt navn
                </label>
                <input
                  type="text"
                  id="fname"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={onChange}
                  name="name"
                />
              </div>
              <div className="w-full">
                <label htmlFor="email" className="block text-sm font-medium">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={onChange}
                />
              </div>
              <div className="w-full">
                <label htmlFor="password" className="block text-sm font-medium">
                  Adgangskode
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="****************"
                  value={formData.password}
                  onChange={onChange}
                />
              </div>
              <div className="w-full">
                <label htmlFor="password" className="block text-sm font-medium">
                  Bekræft adgangskode
                </label>
                <input
                  id="password"
                  name="confirmPassword"
                  type="password"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="****************"
                  value={formData.confirmPassword}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="flex items-center justify-end mb-8 mt-4">
              <a href={Path.forgotPassword} className="text-md hover:text-black">
                Glemt adgangskode?
              </a>
            </div>

            <div className="flex justify-center mb-8">
              <button
                type="button"
                className="py-3 px-20 border border-transparent rounded-full text-sm font-medium text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
                onClick={submit}
              >
                Opret en konto
              </button>
            </div>

            <div className="text-center">
              <p className="text-md">
                Har du allerede en konto?
                <a href={Path.login} className="ml-1 font-bold border-b">
                  Log ind
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
